import YieldDrawDownWrapper from '../../../../components/well-forms/drilling-tests/drilling-test-wrapper'

export default function EditWellDrillingTests() {
  return <YieldDrawDownWrapper />
}
